import React, { Component } from "react";
import Dialog from "../../../Dialog/Dialog";

import "./WriteMessage.css";

class WriteMessage extends Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.uploadFiles = this.uploadFiles.bind(this);
    }
    state = { dialog: null, attachments: null };

    message = "";

    uploadFiles(files) {
        return new Promise((resolve, reject) => {
            if (files.length === 0) resolve([]);
            this.props.connection
                .upload(files, (results, reqs) => {
                    this.setState({
                        dialog: (
                            <Dialog
                                message={
                                    "در حال آپلود فایل ها لطفا منتظر بمانید ..."
                                }
                                progress={{
                                    current: results.length,
                                    total: reqs.length,
                                }}
                            ></Dialog>
                        ),
                    });
                })
                .then((results) => {
                    this.props.toast(
                        "آپلود",
                        "تمام فایل ها با موفقیت آپلود شدند",
                        " confirm"
                    );
                    resolve(results);
                })
                .catch((err) => {
                    this.props.toast(
                        "خطا در آپلود فایل ها",
                        `آپلود با خطا مواجه شد لطفا مجددا تلاش کنید\n
                                            خطا:\n
                                            ${err.code}\n
                                            ${err.name}\n
                                            ${err.message}\n
                                            `,
                        " danger"
                    );
                    reject(err);
                });
        });
    }

    submit(attachments) {
        attachments && attachments.length > 0
            ? this.uploadFiles(attachments)
                  .then((files) => {
                      this.props.send(this.message, files);
                  })
                  .catch((err) => {
                      console.log(err);
                  })
                  .finally(() => {
                      this.setState({ dialog: null });
                  })
            : this.props.send(this.message, null);
    }

    render() {
        let { attachments } = this.state;
        return (
            <div className="WriteMessageComponent">
                <div className="message">
                    <div className="message">
                        <textarea
                            placeholder="پیام خود را اینجا بنویسید"
                            onChange={(ev) => (this.message = ev.target.value)}
                        ></textarea>
                    </div>
                    <div className="attachment">
                        <div className="caption btn thirdary">
                            افزودن پیوست (
                            {attachments ? attachments.length : "خالی"})
                        </div>
                        <input
                            type="file"
                            multiple
                            accept="image/* , video/*"
                            onChange={(ev) => {
                                let attachments = Array.from(ev.target.files)
                                    .map((f) => {
                                        if (f.size > 4194304) {
                                            this.props.toast(
                                                "خطا در پیوست فایل ",
                                                "اندازه فایل " +
                                                    f.name +
                                                    " بیشتر از 4 مگابایت است. این فایل نمیتواند پیوست شود",
                                                " warning"
                                            );
                                            return null;
                                        }
                                        return {
                                            url: URL.createObjectURL(f),
                                            type: f.type,
                                            file: f,
                                        };
                                    })
                                    .filter((f) => {
                                        return f != null;
                                    });

                                let totalSize = 0;

                                attachments.forEach((f) => {
                                    totalSize += f.size;
                                });
                                if (totalSize > 10485760) {
                                    this.props.toast(
                                        "خطا در پیوست فایل ها",
                                        "اندازه کل فایل های پیوست حداکثر 10 مگابایت است . مجموع فایل های شما بیش از 10 مگابایت میباشد.",
                                        " warning"
                                    );
                                } else this.setState({ attachments });
                                ev.target.value = null;
                            }}
                        />
                    </div>
                </div>
                <div className="submit">
                    <button
                        className="btn confirm"
                        onClick={(ev) => this.submit(attachments)}
                    >
                        ثبت درخواست
                    </button>
                </div>
            </div>
        );
    }
}

export default WriteMessage;
